import { create } from 'zustand';

interface ThreatsRealtimeState {
  newAlertsCount: number;
  newViolationsCount: number;
  registerAlert: () => void;
  registerViolation: () => void;
  clearAlerts: () => void;
  clearViolations: () => void;
}

// Tracks alerts/violations created via the realtime socket while the Threats
// page is open, so it can surface a "new items available" banner without
// eagerly refetching or reshuffling whatever page the user is currently on.
export const useThreatsRealtimeStore = create<ThreatsRealtimeState>()((set) => ({
  newAlertsCount: 0,
  newViolationsCount: 0,

  registerAlert: () => set((state) => ({ newAlertsCount: state.newAlertsCount + 1 })),
  registerViolation: () => set((state) => ({ newViolationsCount: state.newViolationsCount + 1 })),

  clearAlerts: () => set({ newAlertsCount: 0 }),
  clearViolations: () => set({ newViolationsCount: 0 }),
}));
